import React from "react";

export const TagIcon = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34px"
      height="34px"
      viewBox="0 0 34 34"
      version="1.1"
    >
      <title>Shape</title>
      <desc>Created with Sketch.</desc>
      <defs />
      <g
        id="Самое-актуальное-"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Web_Search_author_Spotlite-"
          transform="translate(-198.000000, -426.000000)"
          fillRule="nonzero"
          fill="#9BCACE"
        >
          <g id="Group-17" transform="translate(170.000000, 25.000000)">
            <g
              id="Avatar-(no-photo)"
              transform="translate(20.000000, 392.000000)"
            >
              <path
                d="M39.9482759,18.1326815 L35.8078966,18.1326815 L37.2546552,11.6984242 C37.5114138,10.5564525 36.8560345,9.40721863 35.763931,9.0852637 C34.5921034,8.7397068 33.378069,9.47741933 33.1025517,10.7029057 L31.4324483,18.1326815 L21.8485517,18.1326815 L23.2953103,11.6984242 C23.552069,10.5564525 22.8966897,9.40721863 21.8045862,9.0852637 C20.6327586,8.7397068 19.4187241,9.47741933 19.1432069,10.7029057 L17.4731034,18.1326815 L12.6896552,18.1326815 C11.5565172,18.1326815 10.637931,19.0809962 10.637931,20.2508061 C10.637931,21.4206161 11.5565172,22.3689307 12.6896552,22.3689307 L16.5205172,22.3689307 L14.8873448,29.6310721 L10.0517241,29.6310721 C8.91858621,29.6310721 8,30.5793868 8,31.7491967 C8,32.9190066 8.91858621,33.8673213 10.0517241,33.8673213 L13.9347586,33.8673213 L12.488,40.3015786 C12.2312414,41.4435503 12.8866207,42.5927842 13.9787241,42.9147391 C15.1505517,43.260296 16.3645862,42.5225835 16.6401034,41.296492 L18.3102069,33.8673213 L27.8941034,33.8673213 L26.4473448,40.3015786 C26.1905862,41.4435503 26.8459655,42.5927842 27.938069,42.9147391 C29.1098966,43.260296 30.323931,42.5225835 30.5994483,41.296492 L32.2695517,33.8673213 L37.0172414,33.8673213 C38.1503793,33.8673213 39.0689655,32.9190066 39.0689655,31.7491967 C39.0689655,30.5793868 38.1503793,29.6310721 37.0172414,29.6310721 L33.2221379,29.6310721 L34.8553103,22.3689307 L39.9482759,22.3689307 C41.0814138,22.3689307 42,21.4206161 42,20.2508061 C42,19.0809962 41.0814138,18.1326815 39.9482759,18.1326815 Z M28.8466897,29.6310721 L19.2627931,29.6310721 L20.8959655,22.3689307 L30.4798621,22.3689307 L28.8466897,29.6310721 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
